export const includes = <Expected extends Element, Element>(
  collection: ReadonlyArray<Expected>,
  element: Element,
): element is Expected => {
  return collection.includes(element as Expected);
};
